import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, combineReducers, } from 'redux';
import thunkMiddleware from 'redux-thunk';
// import { createLogger } from 'redux-logger';
import { getParts, getInfo, crud, updateUI } from './reducers';
import './index.css';
import App from './containers/App';
import Crud from './containers/Crud';
// import Builder from "./containers/Builder";
import 'tachyons';
import * as serviceWorker from './serviceWorker';

import { Route, BrowserRouter as Router } from 'react-router-dom';

// const logger = createLogger();
const rootReducers = combineReducers({ getParts, getInfo, crud, updateUI });
const store = createStore(rootReducers, applyMiddleware(thunkMiddleware/*, logger*/));

const routing = (
	<Router>
   		<Route exact path={process.env.REACT_APP_ROUTE_MAIN} component={App} />
		{/*<Route exact path={process.env.REACT_APP_ROUTE_MAIN} component={Builder} />*/}
   		<Route exact path={process.env.REACT_APP_ROUTE_CRUD} component={Crud} />
	</Router>
);

ReactDOM.render(
	<Provider store={store}>
		{routing}
	</Provider>, document.getElementById('root'));
	

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
